<div cdkDrag class="sam-full-width dragged-item" *ngIf="collapsed">
   <div class="sam-margin-right-large sam-center" cdkDragHandle>
      <fa-icon class="sam-margin-left sam-center" [icon]="dragIcon"></fa-icon>
   </div>
   <div *cdkDragPreview></div>
   <div
      fxFlex="auto"
      class="tab-brick-description sam-margin-left"
      *ngIf="tabContentBrickDescription$ | async as brickDescription"
   >
      <fa-icon
         [icon]="brickDescription.definition.brickIcon"
         class="sam-margin-right-medium sam-center sam-icon-width"
      ></fa-icon>
      <div class="sam-button-text">
         {{ brickDescription.definition.brickTitleTranslationKey | translate }}
      </div>
   </div>
   <div fxLayout="row" fxLayoutAlign="top center" *samwebVar="tabContent$ | async; let tabContent">
      <samweb-brick-setting-button
         [brickInstanceId]="tabContent?.brickInstanceId"
         class="sam-clickable button-position"
         (click)="selectTab()"
      ></samweb-brick-setting-button>

      <div
         class="sam-clickable button-position"
         *ngIf="isRemoveTabAllowed$ | async"
         (click)="removeTab(tabContent?.brickInstanceId)"
      >
         <fa-icon class="sam-clickable sam-red" [icon]="removeTabIcon"></fa-icon>
      </div>
   </div>
</div>

<div *ngIf="!collapsed" fxLayout="row" class="sam-margin-top">
   <div class="sam-full-width" fxLayout="row">
      <div fxLayout="row" fxFlex="60" [style.margin-bottom]="'5px'">
         <div class="sam-full-width">
            <input
               (input)="tabTitleChanged($event.target.value)"
               [value]="(tabContent$ | async).tabTitle"
               [placeholder]="'brick.brick_definitions.tab-brick.settings.tab_title_placeholder' | translate"
               class="sam-full-width"
               kendoTextBox
            />
         </div>
      </div>

      <div fxLayout="row" fxFlex="1 1 auto" [style.justify-content]="'flex-end'">
         <div>
            <samweb-icon-picker
               fxFlex="1 1 *"
               [value]="(tabContent$ | async).tabIcon | iconNameToIconDefinition$ | async"
               (valueChanged)="tabIconChanged($event)"
            >
            </samweb-icon-picker>
            <kendo-colorpicker
               [format]="'hex'"
               [gradientSettings]="{ opacity: false }"
               [view]="'gradient'"
               [value]="(tabContent$ | async).tabColor"
               (valueChange)="tabColorChanged($event)"
               [style.height]="'fit-content'"
            ></kendo-colorpicker>
            <samweb-clear-button [toolTipText]="'common.clear_color' | translate" (click)="clearTabColor()">
            </samweb-clear-button>
         </div>
      </div>
   </div>
</div>
